import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { deepCopy } from 'deep-copy-ts';
import { WindowService } from 'src/app/shared/components/window/window.service';
import { AttenuationSettings, MitraNetworkParameters, Splitter } from '../state/network-parameters.model.generated';
import { createSimulation, Simulation } from '../state/simulation.model';
import { SimulationService } from '../state/simulation.service';

@Component({
  templateUrl: './simulation-attenuation.component.html',
  styleUrls: ['./simulation-attenuation.component.scss']
})
export class SimulationAttenuationComponent implements OnInit {

  params: MitraNetworkParameters;
  form: FormGroup;
  isHorizontalUnbalanced: boolean;
  splitters: Splitter[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public simulation: Simulation,
    private formBuilder: FormBuilder,
    private simulationService: SimulationService,
    private windowService: WindowService
  ) { }


  ngOnInit(): void {
    if (this.simulation.parameters) {
      this.params = deepCopy(this.simulation.parameters);
    } else {
      this.params = createSimulation({}).parameters;
    }

    if (!this.params.attenuation_settings) {
      this.params.attenuation_settings = DEFAULT_ATTENUATION;
    }

    this.splitters = this.simulationService.getSplitters(this.params);

    this.createForm();

    this.isHorizontalUnbalanced = this.simulationService.isHorizontalUnbalanced(this.params);
  }

  save(): void {
    this.params.attenuation_settings = this.form.value;

    const simulation = createSimulation(this.simulation);
    simulation.parameters = this.params;

    this.simulationService.update(this.simulation.id, simulation)
      .subscribe(s => this.windowService.close(this));
  }


  private createForm() {
    const { attenuation_settings } = this.params;

    this.form = this.formBuilder.group({
      field_connector: [attenuation_settings.field_connector, [Validators.required, Validators.min(0)]],
      factory_connector: [attenuation_settings.factory_connector, [Validators.required, Validators.min(0)]],
      fusion: [attenuation_settings.fusion, [Validators.required, Validators.min(0)]],
      fiber: [attenuation_settings.fiber, [Validators.required, Validators.min(0)]],
      splitter_2: [attenuation_settings.splitter_2, [Validators.required, Validators.min(0)]],
      splitter_4: [attenuation_settings.splitter_4, [Validators.required, Validators.min(0)]],
      splitter_8: [attenuation_settings.splitter_8, [Validators.required, Validators.min(0)]],
      splitter_16: [attenuation_settings.splitter_16, [Validators.required, Validators.min(0)]],
      splitter_32: [attenuation_settings.splitter_32, [Validators.required, Validators.min(0)]],
      cto_1090_c: [attenuation_settings.cto_1090_c, [Validators.required, Validators.min(0)]],
      cto_1090_a: [attenuation_settings.cto_1090_a, [Validators.required, Validators.min(0)]],
      cto_1585_c: [attenuation_settings.cto_1585_c, [Validators.required, Validators.min(0)]],
      cto_1585_a: [attenuation_settings.cto_1585_a, [Validators.required, Validators.min(0)]],
      cto_2080_c: [attenuation_settings.cto_2080_c, [Validators.required, Validators.min(0)]],
      cto_2080_a: [attenuation_settings.cto_2080_a, [Validators.required, Validators.min(0)]],
      cto_2575_c: [attenuation_settings.cto_2575_c, [Validators.required, Validators.min(0)]],
      cto_2575_a: [attenuation_settings.cto_2575_a, [Validators.required, Validators.min(0)]],
      cto_3070_c: [attenuation_settings.cto_3070_c, [Validators.required, Validators.min(0)]],
      cto_3070_a: [attenuation_settings.cto_3070_a, [Validators.required, Validators.min(0)]],
      cto_3565_c: [attenuation_settings.cto_3565_c, [Validators.required, Validators.min(0)]],
      cto_3565_a: [attenuation_settings.cto_3565_a, [Validators.required, Validators.min(0)]],
      cto_4060_c: [attenuation_settings.cto_4060_c, [Validators.required, Validators.min(0)]],
      cto_4060_a: [attenuation_settings.cto_4060_a, [Validators.required, Validators.min(0)]],
      cto_18_a: [attenuation_settings.cto_18_a, [Validators.required, Validators.min(0)]]
    });
  }
}

const DEFAULT_ATTENUATION: AttenuationSettings = {
  field_connector: 0.45,
  factory_connector: 0.25,
  fusion: 0.10,
  fiber: 0.35,
  splitter_2: 4,
  splitter_4: 7.30,
  splitter_8: 10.50,
  splitter_16: 14,
  splitter_32: 17.7,
  cto_1090_c: 0.73,
  cto_1090_a: 21.54,
  cto_1585_c: 1.13,
  cto_1585_a: 20.78,
  cto_2080_c: 1.40,
  cto_2080_a: 18.4,
  cto_2575_c: 1.7,
  cto_2575_a: 17.45,
  cto_3070_c: 2.22,
  cto_3070_a: 16.51,
  cto_3565_c: 2.3,
  cto_3565_a: 15.6,
  cto_4060_c: 2.73,
  cto_4060_a: 15.32,
  cto_18_a: 10.50
};
